<div
  class="button-card"
  [ngClass]="{'disabled': this.disabled}"
>
  @for (b of this.buttons(); track b) {
  <button
    type="button"
    [class]="'btn btn-sm btn-outline-primary me-2 mb-2 ' +this.getClassName(b)"
    (click)="this.onClick(b, $event)"
  >
    {{this.getLabel(b)}}
  </button>
  }
</div>